import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";
import createResolverFactory from "components/QueryClient/ResolverFactory";

export function useAddGatedCustomersAction(onDone) {
  const mutationFactory = useCallback(() => {
    const query = `mutation addGatedCustomers($emails: [String]!) {
        addGatedCustomers(emails: $emails) {
          successMessage
        }
      }`;

    const resolver = ({ data: { addGatedCustomers } }) => {
      return { data: addGatedCustomers };
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const [mutation, { loading }] = useMutationWithToaster(mutationFactory, {
    onDone,
  });

  return {
    addGatedCustomers: ({ emails }) => {
      return mutation(
        { emails },
        {
          defaultErrorMsg: "Failed to add customer practices to access list",
        }
      );
    },
    loading: loading,
  };
}

export default useAddGatedCustomersAction;
